function designToken(type, name) {
	return `var(--${type}-${name})`;
}

export const colorToken = designToken.bind(null, "color");
